<template>
    <plantilla-base></plantilla-base>
</template>

<script>
    import PlantillaBase from "./components/PlantillaBase";
    import {VueRouteHelper} from "./comunes/helpers/VueRouteHelper";

    export default {
        name: 'App',
        components: {PlantillaBase},
        data: () => ({
            ultimoUsuario: null
        }),
        created() {
            this.$store.watch(
                (state, getters) => getters.usuario,
                (newValue, oldValue) => {
                    if (oldValue != null && newValue == null) {
                        VueRouteHelper.goTo("/", this.$router);
                    }
                },
            );
        }
    };
</script>

<style>
    .hand {
        cursor: pointer;
    }

    .cursor-info {
        cursor: help;
    }
</style>